<ng-container *transloco="let t">
  <div class="remove-padding-form-field h-full w-60">
    <mat-form-field class="w-full" style="margin-bottom: 0px !important;">
      <mat-select [formControl]="formControl" [placeholder]="t('common.comune')">
        @for (comune of comuneService?.comuni?.sort(); track comune) {
          <mat-option [value]="comune.slug">
            {{comune.nome}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

</ng-container>
